import DateRangePicker from "@/components/DateRangePicker/dateRangePicker.component";
import TranslatedErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import FilterString from "@/components/FilterString/filterString.component";
import { Label } from "@/shadcn/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcn/components/ui/select";
import { SimpleOrder } from "@/types";
import React from "react";
import { DateRange } from "react-day-picker";

type FiltersOrderTrackingProps = {
  shipped: "all" | SimpleOrder["shipped"];
  setShipped: (shipped: "all" | SimpleOrder["shipped"]) => void;
  acceptedDate: DateRange | undefined;
  setAcceptedDate: (dateRange: DateRange | undefined) => void;
  status: SimpleOrder["status"] | "all";
  setStatus: (status: SimpleOrder["status"] | "all") => void;
  company: string;
  setCompany: (company: string) => void;
  availableCompanies: string[];
};

const FiltersOrderTracking: React.FC<FiltersOrderTrackingProps> = ({
  shipped,
  setShipped,
  acceptedDate,
  setAcceptedDate,
  status,
  setStatus,
  company,
  setCompany,
  availableCompanies,
}) => {
  return (
    <TranslatedErrorBoundary
      fallback={<div className="text-red-600">Error loading filters</div>}
    >
      <div className="flex flex-wrap items-center gap-4">
        <div className="space-y-2">
          <Label>
            Status
            <Select value={status} onValueChange={setStatus}>
              <SelectTrigger className="w-32 capitalize">
                <SelectValue placeholder="Filter by Status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem key={"all"} value={"all"}>
                  All
                </SelectItem>
                <SelectItem key={"in_progress"} value={"in_progress"}>
                  In Progress
                </SelectItem>
                <SelectItem key={"completed"} value={"completed"}>
                  Completed
                </SelectItem>
              </SelectContent>
            </Select>
          </Label>
        </div>
        <div className="space-y-2">
          <Label>
            Out
            <Select value={shipped} onValueChange={setShipped}>
              <SelectTrigger className="w-20">
                <SelectValue placeholder="Filter by Status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem key={"all"} value={"all"}>
                  All
                </SelectItem>
                <SelectItem key={"yes"} value={"Y"}>
                  Yes
                </SelectItem>
                <SelectItem key={"no"} value={"N"}>
                  No
                </SelectItem>
              </SelectContent>
            </Select>
          </Label>
        </div>
        <div className="space-y-2">
          <Label>
            Accepted Date
            <DateRangePicker date={acceptedDate} setDate={setAcceptedDate} />
          </Label>
        </div>
        <FilterString
          filter={company}
          setFilter={setCompany}
          availableFilters={availableCompanies}
          label="Customer"
        />
      </div>
    </TranslatedErrorBoundary>
  );
};

export default FiltersOrderTracking;
